import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ISearchHistoryService = ( createDecorator('searchHistoryService'));
export { ISearchHistoryService };
